import { request, orgBase } from '@/api/http'
import type { ScoringConfig, InventoryScoringOverride } from '@/api/types'

// Org risk-scoring coefficients (§5.4). GET returns stored config or built-in
// defaults; PUT validates + persists and re-scores the org.
export const scoringConfigApi = {
  get(orgId: string): Promise<ScoringConfig> {
    return request(`${orgBase(orgId)}/scoring/config`)
  },
  set(orgId: string, body: ScoringConfig): Promise<ScoringConfig> {
    return request(`${orgBase(orgId)}/scoring/config`, {
      method: 'PUT',
      body: JSON.stringify(body),
    })
  },
  // Per-inventory overrides (null field = inherit org config).
  getInventory(orgId: string, invId: string): Promise<InventoryScoringOverride> {
    return request(`${orgBase(orgId)}/inventories/${invId}/scoring-config`)
  },
  setInventory(
    orgId: string,
    invId: string,
    body: InventoryScoringOverride
  ): Promise<InventoryScoringOverride> {
    return request(`${orgBase(orgId)}/inventories/${invId}/scoring-config`, {
      method: 'PUT',
      body: JSON.stringify(body),
    })
  },
}
